// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-install-styles__root--EEdLa {
  position: fixed;
  bottom: 0px;
  z-index: 100;
  width: calc(100% - 56px);
  margin: 28px;
  background: rgb(255, 255, 255);
  border-radius: 20px;
  border: 1px solid rgb(233, 233, 233);
  height: 152px;
  display: flex;
  flex-direction: column;
}

.app-install-styles__content--YX6QK {
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 32px;
  line-height: 38px;
}

.app-install-styles__bar--NEl_y {
  border-radius: 0px 0px 24px 24px;
  height: 24px;
  width: 100%;
  background: linear-gradient(
    -225deg,
    rgb(17, 92, 202) 0%,
    rgb(12, 132, 220) 50%,
    rgb(2, 212, 254) 100%
  );
}

.app-install-styles__close--IC4zW {
  margin: 0 42px;
}

.app-install-styles__action--dGhRy {
  margin: 0 42px;
  font-size: 48px;
  color: var(--cps-color-blue);
}
`, "",{"version":3,"sources":["webpack://./src/app-install/app-install.styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX;;;;;GAKC;AACH;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B","sourcesContent":[".root {\n  position: fixed;\n  bottom: 0px;\n  z-index: 100;\n  width: calc(100% - 56px);\n  margin: 28px;\n  background: rgb(255, 255, 255);\n  border-radius: 20px;\n  border: 1px solid rgb(233, 233, 233);\n  height: 152px;\n  display: flex;\n  flex-direction: column;\n}\n\n.content {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  font-size: 32px;\n  line-height: 38px;\n}\n\n.bar {\n  border-radius: 0px 0px 24px 24px;\n  height: 24px;\n  width: 100%;\n  background: linear-gradient(\n    -225deg,\n    rgb(17, 92, 202) 0%,\n    rgb(12, 132, 220) 50%,\n    rgb(2, 212, 254) 100%\n  );\n}\n\n.close {\n  margin: 0 42px;\n}\n\n.action {\n  margin: 0 42px;\n  font-size: 48px;\n  color: var(--cps-color-blue);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `app-install-styles__root--EEdLa`,
	"content": `app-install-styles__content--YX6QK`,
	"bar": `app-install-styles__bar--NEl_y`,
	"close": `app-install-styles__close--IC4zW`,
	"action": `app-install-styles__action--dGhRy`
};
export default ___CSS_LOADER_EXPORT___;
